import React from 'react'
import loadable from '@loadable/component'

/* Constants */
import {PLATFORMS, ROUTE_CONFIGS, ROUTE_PATHS} from '../core/route/routeConstants'

/* Components */
import HbRoute from '../components/Route/HbRoute'

/* Routes */
const HomePageV2 = loadable(() => import('./desktop/home/HomePageV2'))
const DynamicPage = loadable(() => import('./mobile/dynamic/DynamicPage'))
const DynamicViewPage = loadable(() => import('./mobile/dynamic-view/DynamicViewPage'))
const StaticPage = loadable(() => import('./mobile/static-page/StaticPage'))
const AuthorsPage = loadable(() => import('./mobile/authors/AuthorsPage'))
const BrandsPage = loadable(() => import('./mobile/brands/BrandsPage'))
const TagPage = loadable(() => import('./desktop/tag/TagPage'))
const MerchantPage = loadable(() => import('./desktop/merchant/MerchantPage'))
const BrandPage = loadable(() => import('./desktop/brand-page/BrandPage'))
const CategoryPage = loadable(() => import('./desktop/category/CategoryPage'))
const ProductDetailPage = loadable(() => import('./desktop/product-detail/ProductDetail'))
const SearchPage = loadable(() => import('./desktop/search/SearchPage'))
const QnaPage = loadable(() => import('./mobile/qna/QnaPage'))
const ProductCommentPage = loadable(() => import('./mobile/product-comment/ProductComment'))
const MerchantsPage = loadable(() => import('./mobile/merchants/MerchantsPage'))

function renderRoutes(routingProps) {
  return [
    /* Home Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].HOME_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].HOME_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].HOME_PAGE]}
      component={HomePageV2}/>,

    /* Merchants Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].MERCHANTS_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].MERCHANTS_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].MERCHANTS_PAGE]}
      component={MerchantsPage}/>,

    /* Dynamic Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].DYNAMIC_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].DYNAMIC_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].DYNAMIC_PAGE]}
      component={DynamicPage}/>,

    /* Dynamic View Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].DYNAMIC_VIEW_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].DYNAMIC_VIEW_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].DYNAMIC_VIEW_PAGE]}
      component={DynamicViewPage}/>,

    /* Static Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].STATIC_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].STATIC_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].STATIC_PAGE]}
      component={StaticPage}/>,

    /* Static Page Preview */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].STATIC_PAGE_PREVIEW}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].STATIC_PAGE_PREVIEW}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].STATIC_PAGE_PREVIEW]}
      component={StaticPage}/>,

    /* Authors Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].AUTHORS_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].AUTHORS_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].AUTHORS_PAGE]}
      component={AuthorsPage}/>,

    /* Brands Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].BRANDS_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].BRANDS_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].BRANDS_PAGE]}
      component={BrandsPage}/>,

    /* Tag Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].TAG_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].TAG_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].TAG_PAGE]}
      component={TagPage}/>,

    /* QNA Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_QNA_PAGE_WITH_PRODUCT_SKU]}
      component={QnaPage}/>,

    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_QNA_PAGE_WITH_PRODUCT_ID}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_QNA_PAGE_WITH_PRODUCT_ID}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_QNA_PAGE_WITH_PRODUCT_ID]}
      component={QnaPage}/>,

    /* Product Comment Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_COMMENT_PAGE_WITH_PRODUCT_SKU]}
      component={ProductCommentPage}/>,

    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_COMMENT_PAGE_WITH_PRODUCT_ID]}
      component={ProductCommentPage}/>,

    /* Product Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_SKU]}
      component={ProductDetailPage}/>,

    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].PRODUCT_DETAIL_PAGE_WITH_PRODUCT_ID]}
      component={ProductDetailPage}/>,

    /* Merchant Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].MERCHANT_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].MERCHANT_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].MERCHANT_PAGE]}
      component={MerchantPage}/>,

    /* Brand Category, Category Page, Hurly Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].CATEGORY_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].CATEGORY_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].CATEGORY_PAGE]}
      component={CategoryPage}/>,
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].BRAND_CATEGORY_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].BRAND_CATEGORY_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].BRAND_CATEGORY_PAGE]}
      component={CategoryPage}/>,
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].HURLY_CATEGORY_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].HURLY_CATEGORY_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].HURLY_CATEGORY_PAGE]}
      component={CategoryPage}/>,

    /* Search Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].SEARCH_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].SEARCH_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].SEARCH_PAGE]}
      component={SearchPage}/>,
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].COLLECTION_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].COLLECTION_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].COLLECTION_PAGE]}
      component={SearchPage}/>,

    /* Brand Page */
    <HbRoute
      routingProps={routingProps}
      key={ROUTE_PATHS[PLATFORMS.DESKTOP].BRAND_PAGE}
      path={ROUTE_PATHS[PLATFORMS.DESKTOP].BRAND_PAGE}
      {...ROUTE_CONFIGS[PLATFORMS.DESKTOP][ROUTE_PATHS[PLATFORMS.DESKTOP].BRAND_PAGE]}
      component={BrandPage}/>
  ]
}

export {renderRoutes}
